var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { lookup } from './lookup';
import { utilities } from '../../../utilities/utilities';
import { Element } from '../../../element/element';
import { Modal } from '../../../component/modal';
export var policies = {
    element: null,
    policiesToShow: [],
    policy: function (policyName, index) {
        var policy = {
            element: null,
            get lookup() {
                return lookup.find(function (p) { return p.name == policyName; });
            },
            initModal: function () {
                var closeBtn = function (content) {
                    return new Element({
                        composer: {
                            content: utilities.html(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                                <button class=\"btn\">", "</button>\n                            "], ["\n                                <button class=\"btn\">", "</button>\n                            "])), content)
                        },
                        events: {
                            click: function () {
                                modal.hide();
                            }
                        }
                    }).render();
                };
                var modal = new Modal({
                    composer: {
                        classes: {
                            dialog: 'modal-xl',
                            body: 'overflow-auto'
                        },
                        header: utilities.html(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n                            <div class=\"d-flex align-items-center gap-2 justify-content-between w-100\">\n                                <h4 class=\"fw-bold\">", "<h4>\n                                ", "\n                            </div>\n                            \n                        "], ["\n                            <div class=\"d-flex align-items-center gap-2 justify-content-between w-100\">\n                                <h4 class=\"fw-bold\">", "<h4>\n                                ", "\n                            </div>\n                            \n                        "])), policy.lookup.modal.title, closeBtn("<i class=\"fa-solid fa-times fa-2x\"></i>")),
                        body: '',
                        footer: utilities.html(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n                            <div class=\"d-flex align-items-center justify-content-end\">\n                                ", "\n                            </div>\n                        "], ["\n                            <div class=\"d-flex align-items-center justify-content-end\">\n                                ", "\n                            </div>\n                        "])), closeBtn("Close"))
                    },
                    events: {
                        show: function () {
                            var modalBody = modal.element.querySelector('.modal-body');
                            var bodyContent = typeof policy.lookup.modal.content === "string"
                                ? utilities.html(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), policy.lookup.modal.content) : policy.lookup.modal.content(modalBody);
                            modalBody.appendChild(bodyContent);
                        }
                    }
                });
                policy.element.addEventListener('click', function () {
                    modal.show();
                });
            },
            init: function () {
                if (policy.lookup.modal) {
                    policy.initModal();
                }
                ;
                if (policy.lookup.onClick) {
                    policy.element.addEventListener('click', function () { return policy.lookup.onClick(); });
                }
            },
            render: function () {
                policy.element = utilities.html(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n                    <button style=\"color:inherit; font-weight:normal !important;\" class=\"btn px-3 bg-transparent p-0 rounded-0 ", "\">", "</button>\n                "], ["\n                    <button style=\"color:inherit; font-weight:normal !important;\" class=\"btn px-3 bg-transparent p-0 rounded-0 ", "\">", "</button>\n                "])), index > 0 ? 'border-start' : '', policy.lookup.title);
                policy.init();
                return policy.element;
            }
        };
        return policy;
    },
    render: function (_policies) {
        var _this = this;
        var activePolicies = Object.entries(_policies).filter(function (_a) {
            var _ = _a[0], value = _a[1];
            return value === true;
        });
        if (activePolicies.length === 0)
            return;
        policies.policiesToShow = activePolicies;
        this.element = utilities.html(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n            <div class=\"d-flex align-items-center justify-content-center m-3\"></div>\n        "], ["\n            <div class=\"d-flex align-items-center justify-content-center m-3\"></div>\n        "])));
        activePolicies.forEach(function (_a, index) {
            var policyName = _a[0];
            _this.element.appendChild(policies.policy(policyName, index).render());
        });
        return this.element;
    }
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
